import { render, staticRenderFns } from "./LostMfaDevice.vue?vue&type=template&id=940986c2&scoped=true"
import script from "./LostMfaDevice.vue?vue&type=script&lang=ts"
export * from "./LostMfaDevice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940986c2",
  null
  
)

export default component.exports